<template>
   <Boyo-Dialog :dialogInfo="dialogInfoData"
   @dialogEvent="dialogEventData">
    <div style="display: flex; flex-direction: row; align-items: flex-start;">
      <!-- 左侧竖向步骤条 -->
      <div style="width: 240px; min-width: 220px; margin-right: 24px;">
        <el-steps direction="vertical" :active="activeValue">
          <el-step
            v-for="(item, index) of activeList"
            :key="index"
            :title="item.processNodeName"
            :status="item.stepStatus || 'process'"
          >
            <template slot="description">
              <div v-if="item.processNodeName === '制单人'">
                {{ item.approvalTime }}
              </div>
              <div v-else>
                <div style="border-top: 1px solid #e4e7ed; margin: 8px 0;"></div>
                <div>流程节点：{{ item.processNodeName || '' }}</div>
                <div>经办人：{{ item.maker || '' }}</div>
                <div v-if="item.stepStatus !== 'process'">备注：{{ item.remark || (item.stepStatus === 'success' ? '通过' : '拒绝') }}</div>
                <div>时间：{{ item.makerTime || '' }}</div>
              </div>
            </template>
          </el-step>
        </el-steps>
      </div>
      <!-- 右侧内容 -->
      <div style="flex: 1; overflow-x: auto;">
        <p style="text-align:left">编号：{{formInfo.data.evaluationNo}}，执行时间：{{formInfo.data.execDate}}</p>
        <!-- 表格部分 -->
        <div style="width: 100%; overflow-x: auto; margin-top: 20px;">
          <div class="evaluationTable">
            <el-table :data="evaluationInfo.data"
                        :header-cell-style="{background: 'white',color: 'black', 'font-size': '16px' }"
                        style="width: 100%">
                <el-table-column v-for="(item, index) of evaluationInfo.fieldList"
                                :key="index"
                                :prop="item.prop"
                                :label="item.label"
                                :width="item.width"
                                align="center">
                <el-table-column v-for="(child, index) of item.child"
                                :key="index"
                                    :prop="child.prop"
                                :label="child.label"
                                :width="child.width"
                                align="center">
                    <template slot-scope="scope">
                    <el-input v-model="scope.row['price'+child.label]"
                                oninput="value=value.replace(/[^\d]/g,'')"
                                :readonly="readonly">
                    </el-input>
                    </template>
                </el-table-column>
                <template slot-scope="scope">
                    <el-input v-if="item.type == 'text'"
                            :clearable="item.clearable"
                            v-model="scope.row[item.prop]"
                            :readonly="readonly">
                    </el-input>
                    <el-input v-else-if="item.type == 'textarea'"
                            v-model="scope.row[item.prop]"
                            :autosize="{ minRows: 2, maxRows: 4 }"
                            type="textarea"
                            :readonly="readonly">
                    </el-input>
                    <span v-else>{{ scope.row[item.prop] }}</span>
                </template>
                </el-table-column>
            </el-table>
            </div>
            <div class="remark">
            <el-table :data="evaluationInfo.remark"
                        border
                        :show-header="false"
                        style="width: 100%;border-top:none">
                <el-table-column prop="remark">
                <template slot-scope="scope">
                    <el-input v-model="scope.row.remark"
                            :autosize="{ minRows: 2, maxRows: 4 }"
                            type="textarea"
                            placeholder="备注" readonly
                            style="text-align:left">
                    </el-input>
                </template>
                </el-table-column>
            </el-table>
            </div>
        </div>
      </div>
    </div>
    <!-- 审核表单 -->
    <div v-if="showAuditForm" style="margin-top: 20px; border-top: 1px solid #ebeef5; padding-top: 20px;">
        <!-- 添加快捷短语区域 -->
    <div class="quick-phrase-area">
        <div class="quick-phrase-label">常用快捷短语:</div>
        <div class="quick-phrase-buttons">
        <el-button 
            v-for="(phrase, index) in quickPhrases" 
            :key="index"
            size="mini"
            @click="insertQuickPhrase(phrase)"
            class="phrase-btn">
            {{ phrase }}
        </el-button>
        </div>
    </div>
        <Boyo-Formtwo
        :formInfo="formInfo2"
        :refObj.sync="formInfo2.ref"
        :listTypeInfo="listTypeInfo"
        >
        </Boyo-Formtwo>
    </div>
  </Boyo-Dialog>
</template>

<script>
import BoyoFormtwo from '@/components/BoyoFormtwo'
import BoyoDialog from '@/components/BoyoDialog'
import config from '@/api/config'

export default {
  name: 'EvaluationDialog',
  components: {
    BoyoFormtwo,
    BoyoDialog
  },
  props: {},
  data() {
    return {
      pingImgUrl: config.pingImgUrl,
      loading: false,
      showAuditForm: false,
      auditTask: null,
      processInstanceId: null,
      makerInfo: '',
      makerTime: '',
      activeValue: 0,
      activeList: [],
      quickPhrases: [
            '同意',
            '不同意',
            '需要补充相关附件',
            '移库结算单'
        ],
        showPhraseManager: false,
        newPhrase: '',
      readonly:true,
      // 评价表相关
      evaluationInfo: {
        id: null,
        remark: [
          {
            remark: ''
          }
        ],
        evaluationNo: '', // 编号
        execDate: '', // 执行时间
        // 地区列表
        departureList: [],
        data: [],
        fieldList: [
          { prop: 'wRank', label: '级别', width: '80' },
          { prop: 'grade', label: '评级', width: '80' },
          { prop: 'wLevel', label: '层次', width: '60' },
          { prop: '', label: '到厂价格（元/吨）', width: '600', child: [] },
          { prop: 'note', label: '标准明细', width: '', type: 'textarea' }
        ]
      },
      formInfo: {
        ref: null,
        labelWidth: '100px',
        data: {
          id: '',
          execDate: '',
          evaluationNo: 1,
          remark: '',
        },
        list: [
          { type: 'text', label: '备注：', value: 'remark', style: 'width:80%'},
        ],
        rules: {
        }
      },
      // 审核表单
      formInfo2: {
        ref: null,
        labelWidth: '100px',
        data: {
          id: '',
          processId: '',
          status: 1,
          remark: '',
        },
        list: [
          { type: 'select流程名称：', label: '流程名称：', value: 'processId', list: 'processId', style: 'width:80%',disabled:true},
          { type: 'selectRadio', label: '审核：', value: 'status', style: 'width:95%', className: 'form_item_one',list:'statusFlag2',unclearable:true},
          { type: 'text', label: '备注：', value: 'remark', style: 'width:80%'},
        ],
        rules: {
          status: [{ required: true, trigger: 'change', message: '请选择' }]
        }
      },
      dialogInfoData: {
            visible: false, // 弹框是否显示
            width: '1200px', // 宽度
            title: {
                add: '评价表数据', // 标题
            },
            type: 'add', // 显示哪个标题
            // 按钮列表
            btList: [
                { label: '审核', type: 'success', icon: '', event: 'save', loading: false},
                { label: '关闭', type: '', icon: '', event: 'close', loading: false }
            ]
        },
      // 列表类型信息
      listTypeInfo: {
        statusFlag2: [{ value: 1, label: '同意' }, { value: 2, label: '不同意' }],
        processId:[]
      }
    }
  },
  mounted () {

     // 获取流程枚举
     this.$api.ThirdPartyInterface.getActProcessConfigPage({pageNum: 1, pageSize: 999,carTypeArray:[2,3], status:1}).then(res => {
      if(res.code == 0) {
        let list1 = res.data.list
        for( let i in list1 ) {
          this.listTypeInfo.processId.push({value: list1[i].processId, enumValue: list1[i].processCode, label: list1[i].name})
        }
      }
    })
  },
  methods: {
    // 显示对话框
    
    dialogShow(dataId, auditDialog = 0, auditTask = null, processInstanceId = null, maker = '', makerTime = '') {
        this.dataId = dataId
        this.auditTask = auditTask
        this.processInstanceId = processInstanceId
        this.makerInfo = maker
        this.makerTime = makerTime
        // 审核按钮和表单显示逻辑参照PaymentAdvDetailDialog.vue
      if (auditTask && auditTask.id) {
        this.showAuditForm = true
        this.dialogInfoData.btList[0].show = true
      } else {
        this.showAuditForm = false
        this.dialogInfoData.btList[0].show = false
      }
      // 流程名称回显
      // 抽一个小工具：把 processId 转成 label 或原值
      const setProcessLabel = () => {
        if (!auditTask) return;                 // 没数据直接返回
        const list = this.listTypeInfo.processId || [];
        const hit  = list.find(i => i.enumValue === auditTask.processId);
        this.formInfo2.data.processId = hit ? hit.value : auditTask.processId;
      };
      // 判断下拉数组是否已经就绪
      if (this.listTypeInfo.processId && this.listTypeInfo.processId.length) {
        this.$nextTick(setProcessLabel);        // 已就绪，立即跑
      } else {
        // 没就绪，watch 等它
        const unwatch = this.$watch(
        () => this.listTypeInfo.processId,
        val => {
          if (Array.isArray(val) && val.length) {
            unwatch();                        // 只跑一次就解绑
            setProcessLabel();
          }
        },
        { immediate: true }                   // 防止当前瞬间已经就绪
        );
    }
      // 重置表单数据
      this.resetFormData()
      // 获取数据详情
        this.getInfo(dataId)
      // 获取审核流程步骤
      if (processInstanceId) {
        this.getProcessSteps(processInstanceId)
      }
      this.dialogInfoData.visible = true
    },
    
    // 重置表单数据
    resetFormData() {
      for (const key in this.formInfo.data) {
        this.formInfo.data[key] = ''
      }
      
      // 重置审核表单
      if (this.showAuditForm) {
        this.formInfo2.data.status = 1
        this.formInfo2.data.remark = ''
      }
    },
    
    // 获取过磅单详情
    getInfo(id) {
      this.loading = true
      this.$api.Evaluation.getPurEvaluationPage({ id: id,pageNum:1,pageSize:50 }).then(res => {
        this.loading = false
        if (res.code == 0 && res.data.list && res.data.list.length > 0) {
          const data = res.data.list[0]
          
          // 填充表单数据
          for (const key in this.formInfo.data) {
            if (key in data) {
              this.formInfo.data[key] = data[key]
            }
          }
          this.evaluationInfo.remark[0].remark = res.data.list[0].remark?res.data.list[0].remark:''
          // 填充表格数据
          this.evaluationInfo.fieldList[3].child = []
          this.$api.Evaluation.getPurEvaluationDetailPage({ evaluationId: res.data.list[0].id }).then(
            res2 => {
              if (res2.code === 0) {
                for (let i in res2.data.list) {
                  if(!this.evaluationInfo.fieldList[3].child.some(iuy=>iuy.label == res2.data.list[i].departName)){
                    this.evaluationInfo.fieldList[3].child.push({
                      prop: 'price'+res2.data.list[i].departName,
                      label: res2.data.list[i].departName,
                      departId: res2.data.list[i].departId,
                      width: '100'
                    })
                  }
                }
                for (let k in res2.data.list) {
                  if(!this.evaluationInfo.data.some(iuy=>iuy.grade == res2.data.list[k].grade)){
                    this.evaluationInfo.data.push({
                      id: res2.data.list[k].id,
                      ['id'+res2.data.list[k].departName]: res2.data.list[k].id,
                      evaluationId: 1,
                      rankId: res2.data.list[k].rankId,
                      wRank: res2.data.list[k].wRank,
                      grade: res2.data.list[k].grade,
                      wLevel: res2.data.list[k].wLevel,
                      note: res2.data.list[k].note,
                      ['price'+res2.data.list[k].departName]: res2.data.list[k].price
                    })
                  } else {
                    this.evaluationInfo.data.forEach((iuyt,m)=>{
                      if(iuyt.grade == res2.data.list[k].grade){
                        this.$set(this.evaluationInfo.data[m],['price'+res2.data.list[k].departName],res2.data.list[k].price)
                        this.$set(this.evaluationInfo.data[m],['id'+res2.data.list[k].departName],res2.data.list[k].id)
                      }
                    })
                  }
                }
                this.dialogInfoData.visible = true
              }
            },
            error => {
              console.log(error)
              this.evaluationLoading = false
            }
          )
          // 发出事件
        //   this.$emit('approvalInfo')
        } else {
          this.$message({ message: res.msg || '获取数据失败', type: 'error' })
        }
      }).catch(err => {
        this.loading = false
        console.error('获取评价单数据出错：', err)
        this.$message({ message: '获取数据失败', type: 'error' })
      })
    },
    
    // 获取审核流程步骤
    getProcessSteps(processInstanceId) {
      this.$api.system.getActProcessEntryPage({ idProcessInstance: processInstanceId, pageNum: 1, pageSize: 999 }).then(res => {
        if (res.code === 0) {
          this.activeList = []
          this.activeValue = 0
          for (let i in res.data.list) {
            if (res.data.list[i].status && i < res.data.list.length) {
              this.activeValue = Number(Number(i) + 1)
            }
            let stepStatus = 'process';
            if (res.data.list[i].status == 1) {
              stepStatus = 'success';
            } else if (res.data.list[i].status == 2) {
              stepStatus = 'error';
            } else {
              stepStatus = 'process';
            }
            this.activeList.push({
              processNodeName: res.data.list[i].processNodeName || '', // 第一行：流程节点名称
              maker: res.data.list[i].status
                ? res.data.list[i].actualApprover
                : (res.data.list[i].approver ? res.data.list[i].approver : res.data.list[i].roleName), // 第二行：经办人
              remark: res.data.list[i].remark || '', // 第三行：备注
              makerTime: res.data.list[i].approvalTime || '', // 第四行：时间
              stepStatus
            });
          }
          // 步骤条最前面插入“制单人”节点
          let maker = this.makerInfo || '暂无';
          let makerTime = this.makerTime || '';
          let approvalTime = maker + (makerTime ? (' ' + makerTime) : '');
          this.activeList.unshift({ processNodeName: '制单人', approvalTime });
          this.activeValue = (this.activeValue || 0) + 1;
        } else {
          this.$message({ message: res.msg, type: 'error' })
        }
      })
    },
    
    dialogEventData(event){
        const dialogInfoData = this.dialogInfoData
        switch (event) {
            case 'save':
            const params = {
            id: this.auditTask.id,
            processId: this.formInfo2.data.processId,
            status: this.formInfo2.data.status,
            remark: this.formInfo2.data.remark
          }
          
          this.loading = true
          this.$api.system.approval(params).then(res => {
            this.loading = false
            if (res.code === 0) {
              this.$message({ message: '审核提交成功', type: 'success' })
              this.dialogInfoData.visible = false
              this.$emit('approvalInfo')
            } else {
              this.$message({ message: res.msg || '审核提交失败', type: 'error' })
            }
          }).catch(err => {
            this.loading = false
            console.error('审核提交出错：', err)
            this.$message({ message: '审核提交失败', type: 'error' })
          })
              break
            case 'close':
                dialogInfoData.visible = false
                break
        }
    },
    
    
    // 对话框关闭事件
    dialogClosed() {
      this.resetFormData()
    },
    insertQuickPhrase(phrase) {
        // 获取当前备注值
        const currentRemark = this.formInfo2.data.remark || '';
        
        // 插入短语到备注中
        if (currentRemark) {
            this.formInfo2.data.remark = currentRemark + ' ' + phrase;
        } else {
            this.formInfo2.data.remark = phrase;
        }
    },
    addNewPhrase() {
        if (this.newPhrase.trim()) {
            this.quickPhrases.push(this.newPhrase.trim());
            this.newPhrase = '';
        }
    },
    removePhrase(index) {
        this.quickPhrases.splice(index, 1);
    },
  }
}
</script>

<style lang="stylus" scoped>
.dialog-footer
  display flex
  justify-content flex-end

.quick-phrase-area {
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
  border: 1px dashed #dcdfe6;
}

.quick-phrase-label {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #606266;
}

.quick-phrase-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.phrase-btn {
  margin: 0;
  white-space: nowrap;
}

.phrase-manager-btn {
  margin: 0;
}

.phrase-manager {
  max-height: 400px;
  overflow-y: auto;
}

.phrase-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.phrase-input {
  flex: 1;
  margin-right: 10px;
}

.phrase-delete-btn {
  flex-shrink: 0;
}

.phrase-add {
  display: flex;
  margin-top: 15px;
}

.phrase-add-input {
  flex: 1;
  margin-right: 10px;
}

.phrase-add-btn {
  flex-shrink: 0;
}

.evaluationTable
  text-align left
.remark>>>.el-table .el-textarea__inner
  text-align left
  border none
  resize none
.evaluationTable>>>.el-table
  td, .cell
    padding 0
  .el-input__inner
    border none
    text-align center
    padding 5px
  .el-textarea__inner
    border none
    resize none
    text-align center
  .el-select .el-input__inner
    font-size 16px
    color black
    font-weight bold
.evaluationTable>>>.el-table tbody tr:hover>td
  background-color white !important
.slotButton
  padding 5px 10px
  font-size 13px
  line-height 1.5
  border-radius 3px
  color #fff
  border 0
  margin-left 3px
.remark>>>.el-table tbody tr:hover>td
  background-color white !important
</style> 


// WEBPACK FOOTER //
// src/components/Custom/EvaluationDialog.vue